const styles = (theme) => ({
  boldText: {
    fontWeight: "bold",
  },
  container: {
    margin: theme.spacing(4),
  },
});
export default styles;
